import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { CustomMoldedRubberGasketProductsRoutingModule } from './custom-molded-rubber-gasket-products-routing.module';
import { CustomMoldedRubberGasketProductsComponent } from './custom-molded-rubber-gasket-products.component';
import { CtaModule } from 'src/app/shared/cta/cta.module';

@NgModule({
  declarations: [CustomMoldedRubberGasketProductsComponent],
  imports: [
    CommonModule,
    CtaModule,
    TabsModule.forRoot(),
    CustomMoldedRubberGasketProductsRoutingModule
  ]
})
export class CustomMoldedRubberGasketProductsModule { }
